export default __webpack_public_path__ + "static/media/blog-img107.0f457d1b.jpg";